module.exports = __webpack_public_path__ + "static/media/07.543388e4.png";